import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useCustomFeeStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  feeBlock: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(palette.shades[300]),
    minHeight: '75px',
    padding: props => props.padding || '24px 40px'
  },
  feeFooter: {
    backgroundColor: palette.info.light,
    borderTop: "1px solid ".concat(palette.shades[300]),
    padding: props => props.padding || '12px 40px'
  },
  feeFooterButtons: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  labels: {
    marginLeft: '10px'
  },
  lateFeeButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .MuiFormControl-root': {
      maxWidth: '200px'
    }
  },
  inputField: {
    maxWidth: '200px',
    '& .MuiSvgIcon-root': {
      marginRight: props => props.label ? '10px' : '0'
    }
  },
  feeRelink: {
    backgroundColor: props => palette[props.backgroundColor || 'info'].light,
    display: 'flex',
    margin: '12px',
    padding: '12px 24px',
    '& .MuiSvgIcon-root': {
      marginRight: '5px'
    }
  },
  feeRelinkText: {
    display: 'flex'
  },
  signToggler: {
    marginRight: '10px'
  },
  smField: {
    maxWidth: '120px'
  },
  toggler: {
    margin: '0 10px 0 20px'
  },
  utilityActions: {
    alignItems: 'center',
    display: 'flex',
    flexShrink: '0',
    justifyContent: 'center'
  }
}));
export default useCustomFeeStyles;